"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutFacade = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2023 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sections_1 = require("./sections");
/**
 * @alpha
 */
var DashboardLayoutFacade = /** @class */ (function () {
    function DashboardLayoutFacade(layout) {
        this.layout = layout;
    }
    /**
     * Creates an instance of DashboardLayoutFacade
     * @param layout - layout to wrap
     */
    DashboardLayoutFacade.for = function (layout) {
        ts_invariant_1.default(sdk_model_1.isDashboardLayout(layout), "Provided data must be IDashboardLayout.");
        return new DashboardLayoutFacade(layout);
    };
    DashboardLayoutFacade.prototype.sections = function () {
        if (this.sectionsCache === undefined) {
            this.sectionsCache = sections_1.DashboardLayoutSectionsFacade.for(this, this.layout.sections);
        }
        return this.sectionsCache;
    };
    DashboardLayoutFacade.prototype.section = function (rowIndex) {
        return this.sections().section(rowIndex);
    };
    DashboardLayoutFacade.prototype.size = function () {
        return this.layout.size;
    };
    DashboardLayoutFacade.prototype.raw = function () {
        return this.layout;
    };
    return DashboardLayoutFacade;
}());
exports.DashboardLayoutFacade = DashboardLayoutFacade;
//# sourceMappingURL=layout.js.map